module.exports = __webpack_public_path__ + "img/394641_B1A67E_75BEBE_7D7256-256px.2e9b5e2c.png";